import { appConstants } from "../../constants/appconstants";
import { getApiCall, postApiCall } from "../../utils/ApiMethods";


const FetchEMEASectorSiteCardAction = () => {
    return async function (dispatch) {
        const data = await getApiCall(`${appConstants.BASE_URL}/sector-specific-portal/links?sector=EMEA`);
        var resData = Object.assign({ type: 'SUCCESS_EMEA_SECTOR_SITE_CARD_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchOneNASectorSiteCardAction = () => {
    return async function (dispatch) {
        const data = await getApiCall(`${appConstants.BASE_URL}/sector-specific-portal/links?sector=NA`);
        var resData = Object.assign({ type: 'SUCCESS_NA_SECTOR_SITE_CARD_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchGlobalPackagingSectorSiteCardAction = () => {
    return async function (dispatch) {
        const data = await getApiCall(`${appConstants.BASE_URL}/sector-specific-portal/links?sector=GLOBAL_PACKAGING`);
        var resData = Object.assign({ type: 'SUCCESS_GLOBAL_PACKAGING_SECTOR_SITE_CARD_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchSupplierPassportSectorSiteCardAction = () => {
    return async function (dispatch) {
        const data = await getApiCall(`${appConstants.BASE_URL}/sector-specific-portal/links?sector=SUPPLIER_PASSPORT`);
        var resData = Object.assign({ type: 'SUCCESS_SUPPLIER_PASSPORT_SECTOR_SITE_CARD_ACTION' }, data);
        dispatch(resData);
    };
};
export {
    FetchEMEASectorSiteCardAction,
    FetchOneNASectorSiteCardAction,
    FetchGlobalPackagingSectorSiteCardAction,
    FetchSupplierPassportSectorSiteCardAction,
}